import axios from 'axios';
import { API_PATH } from '../../../constants';
import * as actions from './actions';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const options = {
  name: 'announcements',
  baseType: 'ANNOUNCEMENTS',
  apiEndpoint: 'announcements'
};
export const getAnnouncements = createMetadataAPIOperations(options).fetch;

export const updatePoll = (pollID, answerID, currentUserID) => dispatch => {
  dispatch(actions.votedForPoll(pollID, answerID, currentUserID));
  return axios.put(`${API_PATH}/polls/${pollID}`, { answer_id: answerID });
};
